module.exports = "/dashboard/components/modal-clock-in-989d1c.html";